import axios from 'axios'

const _axios = axios.create({
  baseURL: '/',
  withCredentials: true, // Check cross-site Access-Control
});

export default _axios;